import { createPaymentClient } from 'grabbitbot-legacy-ui'
import { apiClient } from './client'
import { createScreenerClient } from './screenerClient'

export { apiClient, tokenStorage } from './client'
export const paymentClient = createPaymentClient(apiClient)
export const screenerClient = createScreenerClient(apiClient)
